import { get_config } from '@/config'

const config = get_config()

export class SocketEvent extends Event {
  constructor(
    type: string,
    public data: any,
  ) {
    super(type)
  }
}

export class WebSocketClient extends EventTarget {
  is_connected: boolean = false
  socket!: WebSocket
  token!: string

  private retry = 0
  private max_retry = 3

  constructor() {
    super()
    // this.connect()
  }

  connect() {
    if (!this.token) {
      throw new Error('Auth token missing')
    }
    if (this.socket) {
      this.socket.removeEventListener('open', this.handle_open_binded)
      this.socket.removeEventListener('close', this.handle_close_binded)
      this.socket.removeEventListener('message', this.handle_message_binded)
      this.socket.removeEventListener('error', this.handle_error_binded)
    }
    const url = `${config.assistant.ws}?token=${this.token}`
    this.socket = new WebSocket(url)
    this.socket.addEventListener('open', this.handle_open_binded)
    this.socket.addEventListener('close', this.handle_close_binded)
    this.socket.addEventListener('message', this.handle_message_binded)
    this.socket.addEventListener('error', this.handle_error_binded)
  }

  private handle_open(event: Event) {
    console.log('WebSocket opened')
    this.dispatchEvent(new SocketEvent(event.type, null))
  }
  private handle_error(event: Event) {
    console.log('WebSocket error')
    console.log(event)
    this.dispatchEvent(new SocketEvent(event.type, null))
  }

  private handle_close(event: Event) {
    console.log('WebSocket closed')
    this.is_connected = false
    if (this.retry < this.max_retry) {
      console.log(`WebSocket reconnecting... [retry: ${this.retry}]`)
      this.retry++
      this.connect()
    } else {
      this.dispatchEvent(new SocketEvent(event.type, null))
    }
  }

  private handle_message(event: MessageEvent) {
    event.stopPropagation()
    const data = JSON.parse(event.data)
    if (data.type === 'connected') {
      console.log('WebSocket connected')
      this.is_connected = true
    }
    this.dispatchEvent(new SocketEvent(data.type, data.data))
  }

  handle_open_binded = this.handle_open.bind(this)
  handle_close_binded = this.handle_close.bind(this)
  handle_message_binded = this.handle_message.bind(this)
  handle_error_binded = this.handle_error.bind(this)

  reconnect() {
    this.retry = 0
    this.connect()
  }

  send(data: string) {
    console.log('sending...', data)
    this.socket.send(data)
  }
}
